import { coverStory } from "@/mocks/gua";

export default function CoverSection() {
  return (
    <section id="headline" className="mx-auto max-w-6xl px-4 md:px-6">
      {/* 期刊卷眉 */}
      <div className="flex items-center justify-between border-y border-foreground-200 py-2 text-xs uppercase tracking-[0.25em] text-foreground-500">
        <span>{coverStory.issue}</span>
        <span className="hidden sm:block">负面新闻 · 争议事件 守门人</span>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-center lg:gap-6">
        {/* 文案主体 */}
        <div className="lg:col-span-8">
          <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
            <span className="inline-block h-px w-8 bg-primary-500" />
            {coverStory.kicker}
          </p>
          <h1 className="mt-5 font-display text-3xl font-black leading-snug tracking-tight text-foreground-950 md:text-5xl md:leading-tight">
            {coverStory.title}
          </h1>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
            {coverStory.dek}
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-foreground-600">
            <span className="flex items-center gap-2">
              <i className="ri-user-3-line text-foreground-400" />
              {coverStory.reporter}
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-fire-line text-accent-600" />
              {coverStory.heat}
            </span>
            <span className="flex items-center gap-2">
              <i className="ri-time-line text-foreground-400" />
              阅读约 8 分钟
            </span>
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-2">
            {coverStory.tags.map((t) => (
              <span
                key={t}
                className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900"
              >
                {t}
              </span>
            ))}
            <a
              href="#watch"
              className="ml-auto flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              阅读完整调查
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>

        {/* 封面陪衬 */}
        <div className="lg:col-span-4">
          <div className="relative mx-auto max-w-sm lg:max-w-none">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <img
                src={coverStory.image}
                alt="吃瓜黑网头版封面：温叙白争议事件"
                title="温叙白争议事件头版封面"
                className="h-[340px] w-full object-cover md:h-[420px]"
              />
            </div>
            <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
              <span>本期封面 · 人物争议</span>
              <span className="flex items-center gap-1">
                <i className="ri-camera-line" /> 编辑配图
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}